import { MapPin, Calendar, ChevronRight, MoveRight, MessageCircle } from "lucide-react";
import { socialLinks, palette } from "../style_palete";

export default function Hero() {
  return (
    <section id="inicio" className="relative pt-4 pb-12 md:py-16">
      <div className="pt-16 md:pt-20"></div>

      <div className="mx-auto max-w-7xl px-4 md:px-8">
        {/* MOBILE: Columna única */}
        <div className="md:hidden">
          {/* Logo + Título centrado en móvil */}
          <div className="flex flex-col items-center text-center mb-8">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhFmorPDGVUU8g88S9g-fjXqwrNzMnbD2OGQ&s"
              alt="Kalmares"
              className="h-24 w-24 rounded-full object-cover border-4 border-white shadow-xl mb-4"
            />
            <h1 className="text-4xl font-bold text-gray-900">
              <span style={{ color: palette.primary }}>Kalmares</span>
            </h1>
            <p className="text-xl text-gray-800 font-semibold mt-1">
              Kinesiología & Fisiatría
            </p>
          </div>

          {/* VIDEO PRIMERO en móvil */}
          <div className="mb-8">
            <div className="relative overflow-hidden rounded-2xl shadow-xl">
              <video
                className="w-full h-[300px] object-cover"
                src="/videos/videokalmares.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>

          {/* Descripción */}
          <div className="mb-8 text-center">
            <p className="text-gray-700 leading-relaxed">
              <span className="font-semibold text-gray-900">
                Centro de rehabilitación integral en Castelar.
              </span>{" "}
              Combinamos técnicas modernas con atención personalizada para que
              recuperes tu movilidad y calidad de vida.
            </p>
          </div>

          {/* Botones apilados en móvil */}
          <div className="space-y-4 mb-8">
            <a
              href={socialLinks.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 rounded-xl px-6 py-4 font-bold text-white shadow-lg w-full"
              style={{
                background: `linear-gradient(135deg, ${palette.primary}, ${palette.teal})`,
              }}
            >
              <MessageCircle className="h-5 w-5" />
              <span>Reservar turno</span>
              <MoveRight className="h-5 w-5" />
            </a>

            <a
              href="#servicios"
              className="flex items-center justify-center gap-2 rounded-xl px-6 py-4 font-semibold border-2 border-blue-200 text-blue-700 w-full"
            >
              <span>Nuestras especialidades</span>
              <ChevronRight className="h-5 w-5" />
            </a>
          </div>

          {/* Info contacto compacta */}
          <div className="space-y-3">
            <div className="flex items-center justify-center gap-4">
              <div className="flex items-center gap-2">
                <Calendar className="h-4 w-4 text-blue-500" />
                <span className="font-medium text-gray-700">Turnos por WhatsApp</span>
              </div>
              <div className="h-4 w-px bg-gray-300"></div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-cyan-500" />
                <span className="font-medium text-gray-700">Castelar</span>
              </div>
            </div>
            <p className="text-center text-sm text-gray-500">
              Respuesta rápida • Carlos Casares 1220
            </p>
          </div>
        </div>

        {/* DESKTOP: Layout original de 2 columnas */}
        <div className="hidden md:grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div>
            <div className="flex items-center gap-5 mb-6">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhFmorPDGVUU8g88S9g-fjXqwrNzMnbD2OGQ&s"
                alt="Kalmares"
                className="h-24 w-24 rounded-full object-cover border-4 border-white shadow-lg"
              />
              <div>
                <h1 className="text-5xl font-bold text-gray-900">
                  <span style={{ color: palette.primary }}>Kalmares</span>
                </h1>
                <p className="text-3xl text-gray-800 font-semibold mt-1">
                  Kinesiología & Fisiatría
                </p>
              </div>
            </div>

            {/* Descripción */}
            <div className="mb-10">
              <p className="text-gray-800 text-lg leading-relaxed">
                <span className="font-semibold text-gray-900">
                  Centro de rehabilitación integral en Castelar.
                </span>{" "}
                Combinamos técnicas modernas con atención personalizada para que{" "}
                <span className="text-blue-700 font-semibold">
                  recuperes tu movilidad y calidad de vida.
                </span>
              </p>
            </div>

            {/* Botones */}
            <div className="mt-12 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <a
                href={socialLinks.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-center gap-3 rounded-xl px-7 py-4 font-bold text-white shadow-lg hover:shadow-xl transition-all flex-1 text-center"
                style={{
                  background: `linear-gradient(135deg, ${palette.primary}, ${palette.teal})`,
                }}
              >
                <MoveRight className="h-5 w-5" />
                Reservar turno
              </a>

              <a
                href="#servicios"
                className="inline-flex items-center justify-center gap-2 rounded-xl px-7 py-4 font-semibold border-2 border-blue-200 bg-white text-blue-700 hover:bg-blue-50 hover:border-blue-300 transition-colors flex-1 text-center"
              >
                <ChevronRight className="h-5 w-5" />
                Nuestras especialidades
              </a>
            </div>

            {/* Info contacto */}
            <div className="pt-6 border-t border-gray-100 mt-10">
              <div className="flex flex-wrap items-center gap-6 text-gray-600">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-blue-500" />
                  <span className="font-medium text-gray-700">Turnos por WhatsApp</span>
                </div>

                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4 text-cyan-500" />
                  <span className="font-medium text-gray-700">Castelar, Zona Oeste</span>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-2 pl-6">
                Respuesta rápida • Carlos Casares 1220
              </p>
            </div>
          </div>

          {/* Columna derecha - VIDEO (desktop) */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <video
                className="w-full h-[550px] object-cover"
                src="/videos/videokalmares.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
